import request from '@/utils/request'

//会员提交环境申请
export function user_save_huanjing(data) {
  return request({
    url: 'user_save_huanjing',
    method: 'post',
    data:data
  })
}

//会员查看订单-环境
export function user_huanjing_orderlist(data) {
  return request({
    url: 'user_huanjing_orderlist',
    method: 'post',
    data:data
  })
}

//环境订单详情
export function user_huanjing_detail(data) {
  return request({
    url: 'user_huanjing_detail',
    method: 'post',
    data:data
  })
}

//门户首页查看环境
export function huanjing_look(data) {
  return request({
    url: 'huanjing_look',
    method: 'post',
    data:data
  })
}

//用户申请加入共享开发环境
export function user_gongxiang_save(data) {
  return request({
    url: 'user_gongxiang_save',
    method: 'post',
    data:data
  })
}

//用户更改自己的共享环境加入费用
export function user_save_gongmoney(data) {
  return request({
    url: 'user_save_gongmoney',
    method: 'post',
    data:data
  })
}

//查看自己的共享环境加入申请列表
export function user_gongxiang_look(data) {
  return request({
    url: 'user_gongxiang_look',
    method: 'post',
    data:data
  })
}

//查看自己的共享环境加入申请详情
export function user_ghuanjing_detail(data) {
  return request({
    url: 'user_ghuanjing_detail',
    method: 'post',
    data:data
  })
}

//查看自己的共享环境加入申请详情
export function admin_gongxiang_look(data) {
  return request({
    url: 'admin_gongxiang_look',
    method: 'post',
    data:data
  })
}

//审核共享环境加入申请
export function admin_shenhe_gong(data) {
  return request({
    url: 'admin_shenhe_gong',
    method: 'post',
    data:data
  })
}

//用户查看是否为自己的环境
export function user_is_huanjing(data) {
  return request({
    url: 'user_is_huanjing',
    method: 'post',
    data:data
  })
}

//申请运行资源
export function user_yunxing_save(data) {
  return request({
    url: 'user_yunxing_save',
    method: 'post',
    data:data
  })
}

//用户查看自己的运行资源申请
export function user_yunxing_list(data) {
  return request({
    url: 'user_yunxing_list',
    method: 'post',
    data:data
  })
}

//用户查看自己的运行资源申请详情
export function user_yunxing_detail(data) {
  return request({
    url: 'user_yunxing_detail',
    method: 'post',
    data:data
  })
}

//运行保障级别列表
export function baozhangjibie_list(data) {
  return request({
    url: 'baozhangjibie_list',
    method: 'post',
    data:data
  })
}

//用户获取自己的报名列表
export function user_hdbaoming_list(data) {
  return request({
    url: 'user_hdbaoming_list',
    method: 'post',
    data:data
  })
}

//报名详情
export function baoming_detail(data) {
  return request({
    url: 'baoming_detail',
    method: 'post',
    data:data
  })
}

//用户续费
export function user_gxxufei_save(data) {
  return request({
    url: 'user_gxxufei_save',
    method: 'post',
    data:data
  })
}

//查询用户续费列表
export function user_gxxufei_list(data) {
  return request({
    url: 'user_gxxufei_list',
    method: 'post',
    data:data
  })
}

//用户续费详情
export function user_xufei_detail(data) {
  return request({
    url: 'user_xufei_detail',
    method: 'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/huanjing.js